export default function Disclaimer() {
  return <section id="2-αποποίηση-ευθύνης" className="bg-primary text-primary-foreground py-16 lg:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <h2 className="font-default font-semibold text-[clamp(2rem,5vw,3.5rem)] leading-tight">
              2. Αποποίηση Ευθύνης
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-sans text-xl leading-relaxed opacity-90">
              Η πλατφόρμα κρατήσεων HotelDeals.gr, καθώς και η διαχειρίστρια εταιρεία VLM TRAVEL ΠΑΡΟΧΗ ΤΟΥΡΙΣΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ ΙΚΕ, λειτουργούν αποκλειστικά ως διαμεσολαβητές μεταξύ του πελάτη και του παρόχου καταλύματος. Ως εκ τούτου, δεν φέρουμε καμία απολύτως ευθύνη για τυχόν χρεώσεις, παρακρατήσεις ποσών, ακυρωτικά τέλη ή οικονομικές διαφορές που προκύπτουν από ακυρώσεις ή αλλαγές, βάσει της πολιτικής που εφαρμόζει το κατάλυμα.
            </p>
          </div>
        </div>
      </div>
    </section>;
}